// extracted by mini-css-extract-plugin
module.exports = {"legalLinks":"LegalLinks_legalLinks__EBfmF","legalLink":"LegalLinks_legalLink__jAuZS"};